import { PageContainer } from '@/components';
import { Footer, Header } from '@/components/LoggedLayout/components';
import { t } from 'i18next';
import { KanbanBoard, KanbanFilter } from '../components';

export const DashboardPage = () => {
  return (
    <div className="flex h-full w-full flex-col items-center">
      <Header />
      <main className="flex w-full flex-1 flex-col">
        <PageContainer>
          <div className="flex flex-col gap-5 py-7">
            <p className="text-lg font-black text-gray">
              {t('dashboard_page_title')}
            </p>
            <KanbanFilter />
            <KanbanBoard />
          </div>
        </PageContainer>
      </main>
      <Footer />
    </div>
  );
};
